import React from 'react';
import ThomasAdvertiserListContainer from 'containers/ThomasAdvertiserListContainer';
import ThomasAdvertisersList from 'views/components/ThomasAdvertisers/ThomasAdvertisersList';
import { Link } from 'react-router-dom';
import AdvertisersPageCacheContainer from 'containers/AdvertisersPageCacheContainer';
import SearchBar from 'views/components/SearchBar/SearchBar';
import { getProductNameById, getProductIdByName } from 'util/nameHelper';
const ThomasAdvertiserListPage = ({ match, isAdminUserAuth }) => {
  let product = match.path.split('/')[2];
  product = product ? product.toUpperCase() : null;
  const productId = product ? getProductIdByName(product) : null;
  const title = productId ? getProductNameById(productId) : '';
  console.log('passed variable', isAdminUserAuth);
  return (
    <section>
      {isAdminUserAuth ? (
        <div className="flex-row flex-wrap">
          <h1 className="page-title">{title} Accounts</h1>
          <Link to="/advertisers/add" className="header-title-btn">
            <button className="btn btn-primary">Add new Account</button>
          </Link>
        </div>
      ) : null}

      <section className="card">
        <AdvertisersPageCacheContainer>
          {({ advertisersPageCache, updateCache, updateAdvertiserPage }) => {
            const { sortOptions } = advertisersPageCache;
            return (
              <ThomasAdvertiserListContainer
                advertisersPageCache={advertisersPageCache}
                productId={productId}
              >
                {({ thomasAdvertisers, thomasAdvertisersReduced, loading, resultsCount }) => {
                  return (
                    <>
                      <SearchBar
                        pageCache={advertisersPageCache}
                        updateCache={updateCache}
                        loading={loading}
                        onKeyPressEvent={e => {
                          if (e.key === 'Enter') {
                            const data: any = {
                              advertisersPageCache: {
                                searchTerm: advertisersPageCache.preSearchTerm,
                                from: 0
                              }
                            };
                            updateCache(data);
                          }
                        }}
                        onChangeEvent={value => {
                          const data: any = {
                            advertisersPageCache: {
                              preSearchTerm: value
                            }
                          };
                          updateCache(data);
                        }}
                        onClickEvent={() => {
                          const data: any = {
                            advertisersPageCache: {
                              searchTerm: advertisersPageCache.preSearchTerm
                            }
                          };
                          advertisersPageCache.searchTerm !== advertisersPageCache.preSearchTerm
                            ? updateCache(data)
                            : null;
                        }}
                      />
                      <ThomasAdvertisersList
                        thomasAdvertisers={thomasAdvertisers || []}
                        thomasAdvertisersReduced={thomasAdvertisersReduced || []}
                        productId={productId}
                        updateCache={updateCache}
                        updatePage={updateAdvertiserPage}
                        sortOptions={sortOptions}
                        size={advertisersPageCache.size}
                        from={advertisersPageCache.from}
                        resultsCount={resultsCount}
                      />
                    </>
                  );
                }}
              </ThomasAdvertiserListContainer>
            );
          }}
        </AdvertisersPageCacheContainer>
      </section>
    </section>
  );
};

export default ThomasAdvertiserListPage;
